type TrackingItem = {
  id: string;
  title: string;
  bestOffer?: {
    id: string;
  } | null;
  priceTag?: {
    priceLabel: {
      price: {
        amount: number;
      };
    };
  } | null;
  badgeText?: string | null;
  sourceType?: number;
};

export type RecommenderTrackingData = {
  id: string;
  title: string;
  offerId?: string;
  sellPrice?: number;
  badgeText?: string;
  sourceType?: number;
  type: "event" | "product";
};

export const getRecommenderTrackingData = (
  items: TrackingItem[],
  type: "event" | "product"
): RecommenderTrackingData[] =>
  items.map((item) => ({
    id: item.id,
    title: item.title,
    offerId: item.bestOffer?.id,
    sellPrice: item.priceTag?.priceLabel.price.amount,
    badgeText: item.badgeText || "",
    type,
    sourceType: item.sourceType,
  }));
